export function formatPriceBR(value) {
  if (!value) return "R$ 0,00";

  // Garante que seja número. Em caso de string, converte.
  const numericValue = Number(value);

  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(numericValue);
}
export function formatCurrencyBR(value) {
  if (value === null || value === undefined || value === "") return "";

  // Se vier string "R$ 1.234,56", tenta primeiro extrair somente dígitos
  // e converte para número. Se já for número, ok.
  const numeric = typeof value === "number"
    ? value
    : parseCurrencyBR(value);

  // Formata como moeda BR
  return numeric.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}
export function parseCurrencyBR(value) {
  if (!value) return 0;

  // Remove "R$", espaços e pontos de milhar. Substitui vírgula por ponto.
  let clean = value
    .toString()
    .replace(/\s/g, "")
    .replace("R$", "")
    .replace(/\./g, "")
    .replace(",", ".");

  // Tenta converter para float
  let numeric = parseFloat(clean);
  if (isNaN(numeric)) {
    numeric = 0;
  }
  return numeric;
}

export function formatDateBR(dateString) {
  if (!dateString) {
      return ''; // Retorna uma string vazia para campos vazios
  }

  const date = new Date(dateString);

  if (isNaN(date)) {
      return ''; // Retorna uma string vazia para datas inválidas
  }

  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}

export function formatDateBRV2(dateString) {

  if (typeof dateString !== 'string') {
    console.error('Erro: O valor fornecido não é uma string válida.', dateString);
    return 'Data inválida';
  }

  // Se já estiver no formato DD/MM/YYYY, retorna a própria string
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
    return dateString;
  }

  const dateParts = dateString.split('-');

  // Verifica se a string está no formato esperado (YYYY-MM-DD)
  if (dateParts.length !== 3) {
    console.error('Erro: Formato de data inválido. Esperado: YYYY-MM-DD', dateString);
    return 'Data inválida';
  }

  const [year, month, day] = dateParts;

  // Verifica se os valores são números válidos e se o mês e o dia estão dentro dos intervalos corretos
  if (
    isNaN(year) || isNaN(month) || isNaN(day) ||
    year.length !== 4 ||
    month.length !== 2 || day.length !== 2 ||
    Number(month) < 1 || Number(month) > 12 ||
    Number(day) < 1 || Number(day) > 31
  ) {
    console.error('Erro: Valores inválidos na data.', dateString);
    return 'Data inválida';
  }

  return `${day}/${month}/${year}`;
}

export function scrollToTop(stepContentRef){
  // Aguarda 300ms para garantir que a animação/renderização esteja completa
  console.log('scrollToTop', stepContentRef.current);
  setTimeout(() => {
      if (stepContentRef.current) {
          const top = stepContentRef.current.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({
              top,
              left: 0,

          });
      }
  }, 200);
};


